<template>
  <div class="min-h-screen flex flex-col">
    <!-- NavBar fijo en la parte superior -->
    <NavBarComponent 
      v-show="isSessionActive" 
      class="w-full fixed top-0 left-0 right-0 z-50 h-16"
    />
    
    <!-- Contenedor principal que empieza después del navbar -->
    <div :class="isLoginRoute ? 'flex' : 'flex flex-1 pt-16'">
      <!-- Sidebar fijo en la parte izquierda -->
      <SideBarComponent 
        v-show="isSessionActive" 
        class="hidden md:block fixed left-0 top-16 bottom-0 w-[15%] overflow-y-auto"
      />
      
      <!-- Contenido principal -->
      <main
        :class="[
          mainClass,
          'flex-1 w-full  p-4',
          isSessionActive ? 'sm:w-[85%] sm:ml-[15%]' : '',
        ]"
      >
        <router-view 
        />
      </main>
    </div>
  </div>
</template>

<script>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import NavBarComponent from "./components/NavBarComponent.vue";
import SideBarComponent from "./components/SideBarComponent.vue";
import { useRoute } from "vue-router";

export default {
  components: {
    NavBarComponent,
    SideBarComponent,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    onMounted(() => {
      store.dispatch("loadUserSession");
    });

    const isSessionActive = computed(() => store.getters.getUserSession);
    
    const isLoginRoute = computed(() => 
      route.path.includes('/login')
    );
    const mainClass = computed(() => {
      return isSessionActive.value ? "bg-gray-25" : "bg-black";
    });

    return {
      isSessionActive,
      mainClass,
      isLoginRoute
    };
  },
};
</script>

<style scoped>
/* Asegura que el scroll funcione correctamente */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>